var map = {
	"./404.svg": "a14a",
	"./alarm.svg": "3c85",
	"./app.svg": "43bc",
	"./authentication.svg": "0f31",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./cloud-voucher.svg": "ebf5",
	"./company.svg": "9ef7",
	"./component.svg": "56d6",
	"./component2.svg": "4272",
	"./dashboard.svg": "f782",
	"./device.svg": "2c87",
	"./disable.svg": "a612",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./license.svg": "66a0",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./log (2).svg": "4ae2",
	"./log.svg": "fea0",
	"./map-icon.svg": "6e1d",
	"./market.svg": "3338",
	"./message.svg": "47ff",
	"./model.svg": "63ec",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./node.svg": "ad67",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./phone.svg": "dd82",
	"./plugin.svg": "5e07",
	"./qq.svg": "1430",
	"./region.svg": "cd5e",
	"./safe.svg": "bd01",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./statistics.svg": "a1cf",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./upgrade.svg": "b33e",
	"./user.svg": "b3b5",
	"./user1.svg": "5a8d",
	"./version-icon.svg": "5696",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";